

import  gsap from 'gsap';
import  scrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(scrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    const sections = document.querySelectorAll('.basic-hero-section')

    if(sections.length < 1) return

    sections.forEach(section => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section
            }
        })

        const title = section.querySelector('h1')
        const content = section.querySelectorAll('.basic-hero p')

        const items = [title, ...content]

        if(items.length < 1) return

        tl.to(section, { opacity: 1 })
        tl.to(items, { stagger: 0.1, opacity: 1, translateY: 0, translateX: 0 })
    })

}
